import { ChangeDetectionStrategy, Component, effect, signal } from "@angular/core";

import { AnalyticsClickDirective, ClickAreaDirective } from "@directives";
import { MenuTab, Validator } from "@models";
import { TranslatePipe } from "@pipes";
import { Utils } from "@utils";

import { AbstractTabComponent } from "../abstract/abstract-tab.component";
import { ButtonComponent } from "../button/button.component";
import { SvgComponent } from "../svg/svg.component";
import { TextComponent } from "../text/text.component";

@Component({
  selector: "mn-provably-fair-tab",
  templateUrl: "./provably-fair-tab.component.html",
  styleUrls: ["./provably-fair-tab.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AnalyticsClickDirective, ButtonComponent, SvgComponent, TranslatePipe, TextComponent, ClickAreaDirective],
})
export class ProvablyFairTabComponent extends AbstractTabComponent {
  protected readonly max = Utils.seedLength;

  protected readonly seed = signal<string>(this.acS.cS$());
  protected readonly validators: Validator[] = [this.required, this.maxLength.bind(this), this.alphanumeric];

  constructor() {
    super();

    effect(() => this.seed.set(this.acS.cS$()));
  }

  public info(): void {
    this.acS.mS$.set({ tab: MenuTab.F_I });
  }

  public focused(focused: boolean): void {
    if (!focused) {
      this.seed.set(this.acS.cS$());
    }
  }

  public save(event: Event): void {
    event.stopPropagation();

    this.acS.cS$.set(this.seed());
  }

  private required(value: string): boolean {
    return value !== null && value !== undefined && value.trim().length > 0;
  }

  private maxLength(value: string): boolean {
    return value === null || value === undefined || value.length <= this.max;
  }

  private alphanumeric(value: string): boolean {
    return /^[a-zA-Z0-9]+$/.test(value);
  }
}
